var _effectorFileName = "/src/page-content/home/components/team/team-images.tsx";
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Skeleton } from '@/shared/components/ui/skeleton';
export const TeamImages = () => {
  const IMAGE_UPDATE_TIME = 10000;
  const [imagePaths, setImagePaths] = useState<string[]>([]);
  const [randomImages, setRandomImages] = useState<string[]>([]);
  const imageCache: {
    [key: string]: boolean;
  } = {};
  useEffect(() => {
    const fetchImagePaths = async () => {
      try {
        const response = await fetch('/api/team-images');
        const data = (await response.json()) as string[];
        setImagePaths(data);
        preloadAndSelectImages(data);
      } catch (error) {
        console.log('error fetching image paths: ', error);
      }
    };
    fetchImagePaths();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (imagePaths.length > 0) {
        preloadAndSelectImages(imagePaths);
      }
    }, IMAGE_UPDATE_TIME);
    return () => clearInterval(interval);
  }, [imagePaths]);
  const preloadImage = (src: string) => {
    return new Promise<void>((resolve, reject) => {
      if (imageCache[src]) {
        resolve(); // Image is already cached
        return;
      }
      const img = new window.Image();
      img.src = src;
      img.onload = () => {
        imageCache[src] = true; // Store the preloaded image in the cache
        resolve();
      };
      img.onerror = reject;
    });
  };
  const preloadAndSelectImages = async (paths: string[]) => {
    const shuffled = [...paths].sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 6);

    // Preload the selected images
    await Promise.all(selected.map(preloadImage));
    setRandomImages(selected);
  };
  return <>
      {randomImages.length === 0 && <div className="relative hidden grid-cols-2 place-items-center gap-x-4 sm:grid md:grid-cols-3 md:gap-8">
          <div className="flex w-full animate-float flex-col space-y-4 delay-0 xl:space-y-6">
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
          </div>

          <div className="w-full transform-gpu animate-float space-y-4 delay-300 xl:space-y-6">
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
          </div>

          <div className="hidden w-full animate-float space-y-4 delay-600 md:block xl:space-y-6">
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
            <Skeleton className="mx-auto aspect-square h-auto w-full rounded-2xl" />
          </div>
        </div>}

      {randomImages.length > 0 && <div className="relative hidden grid-cols-3 place-items-center gap-x-4 sm:grid md:grid-cols-3 md:gap-8">
          <div className="flex w-full animate-float flex-col space-y-4 delay-0 xl:space-y-6">
            {randomImages.slice(0, 2).map((path, index) => <Image key={index} className="mx-auto aspect-square h-auto w-full rounded-2xl" width={400} height={400} priority src={path} alt={`Team Member ${index + 1}`} />)}
          </div>

          <div className="w-full transform-gpu animate-float space-y-4 delay-300 xl:space-y-6">
            {randomImages.slice(2, 4).map((path, index) => <Image key={index} className="mx-auto aspect-square h-auto w-full rounded-2xl" width={400} height={400} priority src={path} alt={`Team Member ${index + 1}`} />)}
          </div>

          <div className="w-full animate-float space-y-4 delay-600 md:block xl:space-y-6">
            {randomImages.slice(4, 6).map((path, index) => <Image key={index} className="mx-auto aspect-square h-auto w-full rounded-2xl" width={400} height={400} priority src={path} alt={`Team Member ${index + 1}`} />)}
          </div>

          <GradientBg className="z-0 hidden sm:block lg:hidden" type="circle" origin="center" size={200} />
          <GradientBg className="z-0 hidden sm:hidden lg:block" type="circle" origin="center" size={300} />
        </div>}
    </>;
};